import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/providers";
import { useSeo } from "@/lib/seo";
import { FullLoader } from "@/components/site/Layout";
import { AField, ABtn } from "./ui";

const AdminLogin = () => {
  useSeo("دخول الإدارة");
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/admin-login", f);
      setUser(data);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center bg-[var(--kh-ws)] text-slate-100 px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-[var(--kh-ws-card)] border border-white/5 p-8 space-y-4">
        <div className="flex items-center gap-2 mb-2"><ShieldCheck className="text-[var(--kh-violet-2)]" /><h1 className="font-heading text-xl font-bold">دخول لوحة الإدارة</h1></div>
        {user && user.role !== "admin" && (
          <p className="text-xs text-yellow-200 bg-yellow-500/10 rounded-lg p-3" data-testid="admin-login-denied">
            حسابك الحالي ليس له صلاحية الإدارة. <Link to="/dashboard" className="underline">رجوع للوحة التحكم</Link>
          </p>
        )}
        <AField label="البريد الإلكتروني" type="email" required dir="ltr" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} testid="admin-login-email" />
        <AField label="كلمة المرور" type="password" required dir="ltr" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} testid="admin-login-password" />
        {error && <p className="text-sm text-red-300" data-testid="admin-login-error">{error}</p>}
        <ABtn disabled={busy} className="w-full" data-testid="admin-login-submit">{busy && <Loader2 size={15} className="animate-spin" />}دخول</ABtn>
        <Link to="/forgot-password" data-testid="admin-forgot-link" className="block text-center text-xs text-slate-400 hover:text-white">نسيت كلمة المرور؟</Link>
      </form>
    </div>
  );
};

export const AdminGate = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[var(--kh-ws)]"><FullLoader /></div>;
  if (!user || user.role !== "admin") return <AdminLogin />;
  return children;
};
